import { Contain } from '../Model/Contain';
export class ContainsService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(containId) {
        if (containId) {
            const response = await this.apiService.get('contain/' + containId);
            if (!response.ok) {
                throw new Error(`Error al obtener el parámetro.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener ContainId.`);
        }
    }
    async find() {
        const response = await this.apiService.get('contains');
        if (!response.ok) {
            throw new Error(`Error al obtener los containetros.`);
        }
        const content = await response.json();
        return content.map(contain => new Contain(contain).getState());
    }
    async findDiferentTypes() {
        const response = await this.apiService.get('diferent_types');
        if (!response.ok) {
            throw new Error(`Error al obtener los containetros.`);
        }
        return await response.json();
    }
    async saveContain(contain) {
        if (contain) {
            const response = await this.apiService.post('contain', contain);
            if (!response.ok) {
                throw new Error(`Error al guardar el containetro.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener contain.`);
        }
    }
    async removeContain(contain) {
        if (contain) {
            const response = await this.apiService.post('contain/remove', contain);
            if (!response.ok) {
                throw new Error(`Error al eliminar el containetro.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener contain.`);
        }
    }
}
